import { render, staticRenderFns } from "./formulario_campo_fill.vue?vue&type=template&id=474c40cb&scoped=true&"
import script from "./formulario_campo_fill.vue?vue&type=script&lang=js&"
export * from "./formulario_campo_fill.vue?vue&type=script&lang=js&"
import style0 from "./formulario_campo_fill.vue?vue&type=style&index=0&id=474c40cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474c40cb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
